var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.errors),function(error,errorIndex){return _c('span',{key:errorIndex,staticClass:"italic text-red-600 text-sm"},[_vm._v(_vm._s(error))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }